var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListLock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 6V8H12.5V6C12.5 4.61875 11.3813 3.5 10 3.5C8.61875 3.5 7.5 4.61875 7.5 6ZM6 8V6C6 3.79063 7.79063 2 10 2C12.2094 2 14 3.79063 14 6V8H15C16.1031 8 17 8.89687 17 10V16C17 17.1031 16.1031 18 15 18H5C3.89688 18 3 17.1031 3 16V10C3 8.89687 3.89688 8 5 8H6ZM4.5 10V16C4.5 16.275 4.725 16.5 5 16.5H15C15.275 16.5 15.5 16.275 15.5 16V10C15.5 9.725 15.275 9.5 15 9.5H5C4.725 9.5 4.5 9.725 4.5 10Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "9d048952e072df6585a5fc32ea3abc4f.svg";